module.exports = __webpack_public_path__ + "img/table.d5345830.jpg";